module.exports = __webpack_public_path__ + "static/16-tss-65a90b72c2a77b93c6e10a6757180c0b.jpg";